<template>
  <router-view />
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'App'
};
</script>

<style lang="sass">
@import "@/assets/styles/style"
</style>
